export const providerSearchDistanceOptions: number[] = [10, 20, 30, 40, 50, 100];
